import React, { useEffect, useState } from 'react';

interface BuildInfo {
  buildTime: string;
  buildId: string;
  commitId: string;
}

interface BuildInfoProps {
  className?: string;
  showDetails?: boolean;
}

export const BuildInfo: React.FC<BuildInfoProps> = ({ 
  className = '', 
  showDetails = false 
}) => {
  const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBuildInfo = async () => {
      try {
        const response = await fetch('/build-info.json');
        if (response.ok) {
          const info = await response.json();
          setBuildInfo(info);
        }
      } catch (error) {
        console.log('Build info not available:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBuildInfo();
  }, []);

  if (loading || !buildInfo) {
    return null;
  }

  const formatBuildTime = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleString();
  };

  const getShortCommitId = (commitId: string) => {
    return commitId?.substring(0, 7) || 'unknown';
  };

  const getBuildNumber = (buildId: string) => {
    // Extract build number from CodeBuild ID format: project-name:build-number
    const parts = buildId?.split(':');
    return parts?.[1] || buildId;
  };

  if (!showDetails) {
    return (
      <div className={`build-info-compact ${className}`} style={{
        fontSize: '0.75rem',
        color: '#666',
        opacity: 0.7
      }}>
        Build: {formatBuildTime(buildInfo.buildTime)}
      </div>
    );
  }

  return (
    <div className={`build-info-detailed ${className}`} style={{
      fontSize: '0.8rem',
      color: '#666',
      padding: '8px',
      backgroundColor: '#f5f5f5',
      borderRadius: '4px',
      fontFamily: 'monospace'
    }}>
      <div><strong>Build Time:</strong> {formatBuildTime(buildInfo.buildTime)}</div>
      <div><strong>Build ID:</strong> {getBuildNumber(buildInfo.buildId)}</div>
      <div><strong>Commit:</strong> {getShortCommitId(buildInfo.commitId)}</div>
    </div>
  );
};

export default BuildInfo;
